import { RegionalAirportConfig } from "@/components/RegionalLayout";
import { RegionalVuelosConfig } from "@/components/RegionalVuelos";

export const mppaVuelosConfig: RegionalVuelosConfig = {
  airport: "blb",
  airportCode: "MPPA",
  basePath: "/mppa/vuelos",
  backPath: "/mppa",
};

export const mppaConfig: RegionalAirportConfig = {
  code: "MPPA",
  name: {
    es: "Aeropuerto Internacional de Panamá Pacífico",
    en: "Panama Pacifico International Airport",
  },
  basePath: "/mppa",
  navLinks: [
    {
      label: { es: "Inicio", en: "Home" },
      href: "/mppa",
    },
    {
      label: { es: "Vuelos", en: "Flights" },
      href: "/mppa/vuelos",
    },
    {
      label: { es: "Pasajeros", en: "Passengers" },
      href: "/mppa/pasajeros",
    },
    {
      label: { es: "Aeropuertos", en: "Airports" },
      href: "/aeropuertos",
    },
    {
      label: { es: "Contacto", en: "Contact" },
      href: "/mppa/mantenimiento",
    },
  ],
  contact: {
    phone: "+(507) 316-3777",
    email: "info@tocumenpanama.aero",
    address: {
      es: "Área Especial Panamá Pacífico, Panamá",
      en: "Panama Pacifico Special Area, Panama",
    },
  },
  socialLinks: {
    facebook: "https://facebook.com/tocumenairport",
    instagram: "https://instagram.com/tocumenairport",
    twitter: "https://twitter.com/tocumenairport",
  },
};
